import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Tc } from '../../types/common';
import { Observable } from 'rxjs';

@Injectable()
export class CampaniasService {
    private endpointUrl = this.baseUrl + 'api/campanias/';
    constructor(
        private http: HttpClient,

        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getProvinciasByPeriodoAmbitoProvincia(idPeriodoCam: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.endpointUrl + 'PeriodoProvinciaCam/' + idPeriodoCam);
    }

    getProvinciasByPeriodoAmbitoCa(idPeriodoCam: number, idCa: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.endpointUrl + 'PeriodoAmbitoCa/Provincias/' + idPeriodoCam + '/' + idCa);
    }
}
